<template>
    <div>
        <div v-if="bill.state === 'COMPLETED'">
            <h3 class="text-5 text-center mb-3">Insurance and Zinara Purchase Receipt</h3>
            <div class="row">
                <p class="col-sm-4 text-muted text-sm-right mb-0 mb-sm-3">VRN : </p>
                <p class="col-sm-8"><strong>{{ bill.vrn }}</strong></p>
            </div>
            <div class="row">
                <p class="col-sm-4 text-muted text-sm-right mb-0 mb-sm-3">Insurance Reference  : </p>
                <p class="col-sm-8"><strong>{{ bill.invoice_id }}</strong></p>
            </div>
            <div class="row">
                <p class="col-sm-4 text-muted text-sm-right mb-0 mb-sm-3">Insurance Payment Reference  : </p>
                <p class="col-sm-8"><strong>{{ bill.response.paymentReference }}</strong></p>
            </div>

            <div class="row">
                <p class="col-sm-4 text-muted text-sm-right mb-0 mb-sm-3">Delivery Type : </p>
                <p class="col-sm-8"><strong>{{ bill.delivery_type }}</strong></p>
            </div>
            <div class="row">
                <p class="col-sm-4 text-muted text-sm-right mb-0 mb-sm-3">Amount : </p>
                <p class="col-sm-8"><strong>ZWG {{ bill.actual_amount }}</strong></p>
            </div>
            <div class="row" v-if="bill.delivery_type === 'DELIVERY'">
                <p class="col-sm-4 text-muted text-sm-right mb-0 mb-sm-3">Delivery Address : </p>
                <p class="col-sm-8"><strong>{{ bill.delivery_address }}</strong></p>
            </div>
            <div class="row" v-if="bill.delivery_type === 'DELIVERY'">
                <p class="col-sm-4 text-muted text-sm-right mb-0 mb-sm-3">Delivery Status : </p>
                <p class="col-sm-8"><strong>{{ bill.delivery_status }}</strong></p>
            </div>
            <div class="row" v-if="bill.delivery_type === 'DELIVERY' && bill.delivery_status === 'PENDING'">
                <div class="col-sm-4 text-muted text-sm-right mb-0 mb-sm-3">Delivery : </div>
                <div class="col-sm-8">
                    <p>To complete delivery kindly complete payment of ZWG {{ deliveryFee }} on ecocash </p>
                    <p><button @click.prevent="deliveryPayment" :class="['btn btn-primary' , loading ? 'btn-loading' : '']">Click Here</button> </p>
                </div>
            </div>

            <div class="row">
                <p class="col-sm-4 text-muted text-sm-right font-weight-500 mb-0 mb-sm-3">Ref : </p>
                <p class="col-sm-8 font-weight-500">{{ transaction.customer_reference }}</p>
            </div>
            <div v-if="transaction.payment_type ==='App\\EcocashPayment'" class="row">
                <p class="col-sm-4 text-muted text-sm-right font-weight-500 mb-0 mb-sm-3">Payment Reference : </p>
                <p class="col-sm-8 font-weight-500">{{ payment.ecocash_reference }}</p>
            </div>

            <div class="form-group mt-5">
                <button @click="submit" :class="['btn btn-primary btn-block' , loading ? 'btn-loading' : '']">Refresh</button>
            </div>
        </div>
        <div v-if="init || bill.state === 'GENERATING-ZINARA'">
            <h3 class="text-5 text-center mb-5">Purchasing... </h3>
            <div  class="text-center text-primary text-20 line-height-07 mb-5 d-flex justify-content-center align-items-center">
                <div class="loader"></div>
            </div>
            <p v-if="countDown > 0" class="text-center text-primary text-8 line-height-07 mb-5">
                {{ this.countDown }}
            </p>
            <p class="text-center text-4 mb-5">Your Payment was successful we are generating your Insurance & Zinara</p>
            <p v-if="" class="text-center text-1">To quickly check progress click below.</p>
            <div class="form-group">
                <button @click="submit" :class="['btn btn-primary btn-block' , loading ? 'btn-loading' : '']">Refresh</button>
            </div>
        </div>
        <div v-if="bill.state === 'ZINARA-FAILED'">
            <h3 class="text-5 text-center mb-5">Zinara Purchase Receipt</h3>

            <p class="text-center text-4 mb-5">
                Oops! Looks like the Airtime system is a little unstable right now and your recharge may take longer to be delivered. You do not have to do anything. You will receive the recharge as soon as it becomes available. This usually takes at most 1 hour. Contact Magetsi Support if you need any assistance.
            </p>

            <div class="row">
                <p class="col-sm-4 text-muted text-sm-right font-weight-500 mb-0 mb-sm-3">Ref : </p>
                <p class="col-sm-8 font-weight-500">{{ transaction.ref }}</p>
            </div>
            <div v-if="transaction.payment_type ==='App\\EcocashPayment'" class="row">
                <p class="col-sm-4 text-muted text-sm-right font-weight-500 mb-0 mb-sm-3">Payment Reference : </p>
                <p class="col-sm-8 font-weight-500">{{ payment.ecocash_reference }}</p>
            </div>

            <p v-if="" class="text-center text-1">To quickly check progress click below.</p>
            <div class="form-group">
                <button @click="submit" :class="['btn btn-primary btn-block' , loading ? 'btn-loading' : '']">Refresh</button>
            </div>
        </div>
    </div>

</template>

<script>
    import Form from "../../../core/forms/form";

    export default {
        name: "ecocash.vue",
        data()
        {
            return {
                rate : 0.6,
                bill : {},
                payment : {},
                deliveryFee : '',
                transaction : {},
                loading: false,
                init: true,
                countDown : 5,
                ref : this.$route.query.id,
                form : new Form({
                    ref : this.$route.query.id,
                    ecocash : ''
                })
            };

        },
        methods : {

            deliveryPayment()
            {
                this.form.submit('/zinara/delivery/init').then((response) => {
                    // Redirect based on payment type
                    if (response.data.success)
                    {
                        if (response.data.body.payment.payment === "ecocash")
                        {
                            this.$router.push(`/zinara/ecocash?id=${response.data.body.payment.ref}`);
                        }
                    }
                });

            },

            submit()
            {
                if (this.loading)
                {
                    return;
                }

                this.loading = true;
                this.countDown = 0;

                // Check Payment

                window.axios['post'](`${window.location.origin}/zinara/complete/check` , {
                    ref : this.ref
                }).then((response) => {

                    this.init = false;
                    if (response.data.success)
                    {
                        this.bill = response.data.body.bill;
                        this.deliveryFee = response.data.body.deliveryFee;
                        this.rate = response.data.body.rate;
                        this.payment = response.data.body.payment;
                        this.form.ecocash = this.payment.phone;
                        this.transaction = response.data.body.transaction;
                        if (this.bill.state === 'GENERATING-AIRTIME')
                        {
                            this.countDown = 30;
                            this.startCountDown();
                        }
                    }

                }).finally(() => {
                    this.loading = false;
                });


            },
            startCountDown()
            {
                if(this.countDown > 0)
                {
                    setTimeout(() => {
                        this.countDown -= 1;
                        this.startCountDown();
                    }, 1000);

                } else {

                    if (!this.loading && !this.done)
                    {
                        this.submit();
                    }
                }
            },
        },

        mounted()
        {
            this.submit();
        }
    }
</script>

<style scoped>

</style>
